import type { CardProps } from 'src/notifications/cardTypes';
import DocumentActions from '../DocumentActions';
import NotificationCardShell from '../NotificationCardShell';
import NotificationLinkButton from '../NotificationLinkButton';

export default function MeetingNoteCompleteCard({
  notification,
  payload,
  onClose,
}: CardProps<'MEETING_NOTE_COMPLETE'>) {
  const failed = payload.status === 'FAILED';
  const editPath = `/client/${payload.client_id}/document/meeting-notes/${payload.meeting_note_id}/edit`;

  return (
    <NotificationCardShell
      notification={notification}
      title={failed ? 'Meeting note failed' : 'Meeting note ready'}
      body={
        failed
          ? 'Your meeting note could not be generated.'
          : 'Your meeting note has been generated.'
      }
      clientId={payload.client_id}
      actions={
        <>
          <NotificationLinkButton
            primary
            to={`/client/${payload.client_id}/document/meeting-notes`}
            onClose={onClose}
          >
            View
          </NotificationLinkButton>
          {!failed && (
            <DocumentActions
              clientId={payload.client_id}
              documentId={payload.meeting_note_id}
              fileId={payload.file_id}
              editPath={editPath}
              email={{ type: 'MEETING_NOTE', label: 'Meeting note' }}
              onClose={onClose}
            />
          )}
        </>
      }
    />
  );
}
